// The host app's runtime config, for use from shared addon code.
//
// An addon cannot `import config from '<app>/config/environment'` because it
// does not know the host app's module name. ember-get-config solved that by
// injecting the app's modulePrefix at build time via an @embroider/macros
// config, then resolving the module by name -- which it did with the AMD
// `require` global, so it breaks under vite where no AMD loader exists.
//
// Every ember-cli build, classic and vite alike, emits the app's config as a
// URI-encoded JSON meta tag named '<modulePrefix>/config/environment'. Reading
// it by suffix needs no module name, so no build-time macro and no dependency.
const meta = document.querySelector('meta[name$="/config/environment"]');

// AppConfig types the keys shared code reads; apps add their own on top.
export interface AppConfig {
  modulePrefix: string;
  environment: string;
  appEnvironment: string;
  appRegionPrefix: string;
  appVersion: string;
  APP: {
    apiHost: string;
    apiPath: string;
    [key: string]: unknown;
  };
  oauth: {
    baseUri: string;
    clientId: string;
    scopes: string[];
    refreshLeeway: number;
    debugEnabled?: boolean;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

if (!meta) {
  throw new Error(
    'linced-common: could not find the app config meta tag (looked for a <meta> whose name ends in "/config/environment").',
  );
}

// The build always writes `content`.
export default JSON.parse(
  decodeURIComponent(meta.getAttribute('content') as string),
) as AppConfig;
